// extracted by mini-css-extract-plugin
export default {"addButton":"add-link-addButton-MZnokg"};